<template>
    <v-container>
      <v-row v-if="!MobileSize">
        <v-col cols="12" md="3" sm="4" :class="IpadProSize || IpadSize ? 'pr-0' : ''">
          <v-card class="mt-3" max-height="100%" min-height="700px">
            <v-list nav>
              <v-list-item style="cursor: pointer;">
                <v-list-item-icon :style="{'margin-right': IpadProSize || IpadSize ? '0px' : ''}">
                  <v-icon color="" left>mdi-home</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title @click="changePath('/')" style="white-space: normal; font-weight: bold; font-size: 18px !important; line-height: 30px;">กลับไปหน้าการซื้อขาย</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-list-group v-for="item in userDetailSelling.position === 'sales' ? itemsSales : itemsAdmin" :prepend-icon="IpadProSize || IpadSize ? false : item.action" :key="item.keys" v-model="item.active" no-action color="#27AB9C">
                <template v-slot:activator>
                  <v-list-item-content v-if="IpadProSize || IpadSize">
                    <v-list-item-title style="white-space: normal; font-weight: bold; font-size: 18px !important; line-height: 24px;">
                      <v-icon left>{{ item.action }}</v-icon>
                      <span>{{ item.title }}</span>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-content v-else>
                    <v-list-item-title v-text="item.title" style="white-space: normal; font-weight: bold; font-size: 18px !important; line-height: 24px;"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item-group v-model="selectedItem" :mandatory="selectedItem!=-1">
                  <v-list-item v-for="child in item.items" :key="child.key" color="#27AB9C" dense :class="IpadProSize || IpadSize ? 'pl-3': 'pl-16'">
                    <v-list-item-content @click="changePath(child.path)">
                      <v-list-item-action v-text="child.title" style="white-space: normal; font-size: 18px !important; line-height: 24px;"></v-list-item-action>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list-group>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="12" md="9" sm="8">
          <v-main style="padding: 0px;">
            <v-container :class="IpadProSize || IpadSize ? 'px-0' : ''">
              <v-card max-height="100%" height="100%">
                <router-view></router-view>
              </v-card>
            </v-container>
          </v-main>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import { Decode } from '@/services'
export default {
  created () {
    this.$EventBus.$emit('getPath')
    this.$EventBus.$emit('changeAppBarGracz')
    this.$EventBus.$on('changeNav', this.changeNav)
    this.$EventBus.$on('changeToUserProfile', this.changeToUserProfile)
    if (localStorage.getItem('oneData') === null || localStorage.getItem('UserDetailSelling') === null) {
      this.$EventBus.$emit('changeAppBarPanit')
      this.$router.push({ path: '/' }).catch(() => {})
    }
    if (localStorage.getItem('UserDetailSelling') !== null) {
      this.userDetailSelling = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
    }
    this.changeNav()
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  watch: {
    selectedItem (val) {
      // console.log(val)
    },
    MobileSize (val) {
      if (this.$router.currentRoute.name === 'GraczUserProfileDetail') {
        if (val === true) {
          this.$router.push({ path: '/Order/UserProfileDetailMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/UserProfileDetail' }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczUserProfile') {
        if (val === true) {
          this.$router.push({ path: '/Order/UserProfileMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/UserProfile' }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczSalesOrder') {
        if (val === true) {
          this.$router.push({ path: '/Order/SalesOrderMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/SalesOrder' }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczSalesOrderDetail') {
        this.orderNumber = this.$route.query.orderNumber
        if (val === true) {
          this.$router.push({ path: `/Order/SalesOrderDetailMobile?orderNumber=${this.orderNumber}` }).catch(() => {})
        } else {
          this.$router.push({ path: `/Order/SalesOrderDetail?orderNumber=${this.orderNumber}` }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczSalesCustomerList') {
        if (val === true) {
          this.$router.push({ path: '/Order/SalesCustomerListMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/SalesCustomerList' }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'GraczSalesCustomerDetail') {
        if (val === true) {
          this.$router.push({ path: '/Order/SalesCustomerDetailMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/SalesCustomerDetail' }).catch(() => {})
        }
      } else if (this.$router.currentRoute.name === 'SalesGraczDashbord') {
        if (val === true) {
          this.$router.push({ path: '/Order/SalesDashbordMobile' }).catch(() => {})
        } else {
          this.$router.push({ path: '/Order/SalesDashbord' }).catch(() => {})
        }
      }
    }
  },
  computed: {
    MobileSize () {
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadSize () {
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    IpadProSize () {
      const { md } = this.$vuetify.breakpoint
      return !!md
    }
  },
  data () {
    return {
      selectedItem: 0,
      select: 0,
      itemsSales: [
        {
          action: 'mdi-account',
          active: true,
          keys: 1,
          items: [
            { key: 0, title: 'ข้อมูลของฉัน', path: 'Order/UserProfileDetail' },
            { key: 1, title: 'รายการสั่งซื้อสินค้า', path: 'Order/SalesOrder' },
            { key: 2, title: 'รายชื่อลูกค้า', path: 'Order/SalesCustomerList' },
            { key: 3, title: 'แดชบอร์ดรายงานการสั่งซื้อ', path: 'Order/SalesDashbord' }
          ],
          title: 'บัญชีของฉัน'
        }
      ],
      itemsAdmin: [
        {
          action: 'mdi-account',
          active: true,
          keys: 1,
          items: [
            { key: 0, title: 'ข้อมูลของฉัน', path: 'Order/UserProfileDetail' }
          ],
          title: 'บัญชีของฉัน'
        }
      ],
      userDetailSelling: '',
      orderNumber: ''
    }
  },
  methods: {
    async changePath (val) {
      if (val === '/') {
        await localStorage.removeItem('OnlinePurchase')
        this.$EventBus.$emit('OnlinePurchase')
        this.$router.push({ path: `${val}` }).catch(() => {})
      } else {
        this.$router.push(`/${val}`).catch(() => {})
      }
    },
    changeNav () {
      if (this.$router.currentRoute.name === 'GraczUserProfileDetail') {
        this.selectedItem = 0
        this.select = 0
      } else if (this.$router.currentRoute.name === 'GraczSalesOrder' || this.$router.currentRoute.name === 'GraczSalesOrderDetail') {
        this.selectedItem = 1
        this.select = 1
      } else if (this.$router.currentRoute.name === 'GraczSalesCustomerList' || this.$router.currentRoute.name === 'GraczSalesCustomerDetail') {
        this.selectedItem = 2
        this.select = 2
      } else if (this.$router.currentRoute.name === 'SalesGraczDashbord') {
        this.selectedItem = 3
        this.select = 3
      }
    },
    changeToUserProfile () {
      this.selectedItem = 0
      this.select = 0
    },
    closeMenu (val) {
      this.selectedItem = val
    }
  }
}
</script>

<style scoped>
.backgroundPage{
  background-color: #F6F6F6;
}
.container {
  max-width: 100%;
}
</style>
